export enum EKycStatus {
  APPROVED = 'APPROVED', //ApplicationStatus.APPROVED
  PENDING= 'PENDING', // Aqui no se tiene un resultado de KYC
  BLACK_LISTED = 'BLACK_LISTED', //ApplicationStatus.BLACK_LISTED
  MANUAL_REVIEW = 'MANUAL_REVIEW', // ApplicationStatus.SUBMITTED
  PENDING_QUESTIONS = 'PENDING_QUESTIONS', // ApplicationStatus.BLACK_LIST_QUESTIONS
  PENDING_DOCUMENTS = 'PENDING_DOCUMENTS' // ApplicationStatus.BLACK_LIST_DOCUMENTS
}